export interface FAQ {
  question: string;
  answer: string;
}

export const faqs: FAQ[] = [
  {
    question: '17c一起是什么？',
    answer: '17c一起是一个汇聚志同道合伙伴的互动社交平台。我们致力于连接有共同兴趣爱好的人，让大家可以一起行动、一起分享、一起成长。无论你喜欢户外运动、音乐艺术、美食烹饪还是读书学习，都能在这里找到属于你的社群。',
  },
  {
    question: '如何加入17c一起？',
    answer: '你只需要在我们的平台上注册一个账号，选择你感兴趣的领域，就可以开始浏览和参加各种活动了。我们也欢迎你主动发起活动，邀请社区的小伙伴一起参与。注册完全免费！',
  },
  {
    question: '参加活动需要付费吗？',
    answer: '大部分社区交流活动是免费的，例如读书会、桌游之夜、音乐交流会等。部分活动（如烘焙课程、户外旅行）可能会涉及材料费或场地费，我们会在活动详情中明确标注，确保价格透明。',
  },
  {
    question: '我是新手，会不会跟不上？',
    answer: '完全不用担心！17c一起的活动大部分都面向所有水平的人开放。无论是户外新手还是资深玩家，都能找到适合自己的活动。我们的社区氛围非常友好，大家都乐于帮助新人。',
  },
  {
    question: '如何发布自己的活动？',
    answer: '登录后点击"发起活动"按钮，填写活动名称、时间、地点、人数限制等信息即可发布。发布后你的活动会出现在相应分类中，感兴趣的小伙伴会报名参加。社区达人还可以申请成为认证活动组织者。',
  },
  {
    question: '活动有人数限制吗？',
    answer: '是的，为了保证活动体验，每个活动都会设置参与人数上限。热门活动建议尽早报名。如果某个活动已满，你可以关注类似的其他活动，或者等待下次机会。',
  },
  {
    question: '如何联系17c一起的团队？',
    answer: '你可以通过"关于我们"页面上的联系表单与我们取得联系，也可以发送邮件到我们的官方邮箱。我们的团队会在24小时内回复你的咨询。',
  },
];